import React, { useState, useEffect } from "react";

const Dashboard = () => {
  const [classes, setClasses] = useState(0);
  const [students, setStudents] = useState(0);
  const [events, setEvents] = useState([]);
  const [devNotes, setDevNotes] = useState([]);

  useEffect(() => {
    // Simulated mock data
    const mockClasses = 12;
    const mockStudents = 243;

    const mockEvents = [
      {
        id: 1,
        date: "2025-06-15",
        title: "Parents' Orientation",
        description: "An event to introduce new parents to our school system.",
      },
      {
        id: 2,
        date: "2025-06-25",
        title: "Sports Day",
        description: "Annual sports competition for all grades.",
      },
    ];

    const mockDevNotes = [
      {
        id: 1,
        created_at: "2025-06-01",
        title: "New Dashboard UI",
        message:
          "The dashboard interface has been redesigned for better usability.",
      },
      {
        id: 2,
        created_at: "2025-06-05",
        title: "Backup Feature",
        message:
          "Quick backup button now works instantly to download your data.",
      },
    ];

    // Simulate async delay
    setTimeout(() => {
      setClasses(mockClasses);
      setStudents(mockStudents);
      setEvents(mockEvents);
      setDevNotes(mockDevNotes);
    }, 500); // delay for UX realism
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleBackup = () => {
    alert("Backup functionality is disabled in demo mode.");
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-page-main">
        <div className="dashboard-page">
          <div className="first-row">
            <div className="dashboard-summary box">
              <h2 className="main-heading">Summary</h2>
              <div className="summary-content">
                <div className="summary-item">
                  <span className="summary-label">Total Classes</span>
                  <span className="summary-value">{classes}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Total Students</span>
                  <span className="summary-value">{students}</span>
                </div>
              </div>
            </div>
            <div className="dashboard-backup box">
              <h2 className="main-heading">Quick Backup</h2>
              <button className="backup-button" onClick={handleBackup}>
                Backup Now
              </button>
            </div>
          </div>

          <div className="dashboard-events box">
            <h2 className="main-heading">Upcoming Events</h2>
            <div className="events-list">
              {events.length > 0 ? (
                events.map((event) => (
                  <div key={event.id} className="event-item">
                    <strong>{event.date}</strong>
                    <h3>{event.title}</h3>
                    <p>{event.description}</p>
                  </div>
                ))
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">📅</div>
                  <div className="empty-text">No Upcoming Events</div>
                  <div className="empty-subtext">
                    Events will appear here when scheduled
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-dev-notes box">
          <h2 className="main-heading">Developer Notices</h2>
          <div className="notes-list">
            {devNotes.length > 0 ? (
              devNotes.map((note) => (
                <div key={note.id} className="note-item">
                  <div className="note-header">
                    <span className="note-date">
                      {formatDate(note.created_at)}
                    </span>
                    <h3 className="note-title">{note.title}</h3>
                  </div>
                  <p className="note-message">{note.message}</p>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <div className="empty-icon">📝</div>
                <div className="empty-text">No Developer Notices</div>
                <div className="empty-subtext">
                  All development updates will appear here
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
